import { render, staticRenderFns } from "./UpdatesPage.vue?vue&type=template&id=19ad3351&scoped=true&"
import script from "./UpdatesPage.vue?vue&type=script&lang=js&"
export * from "./UpdatesPage.vue?vue&type=script&lang=js&"
import style0 from "./UpdatesPage.vue?vue&type=style&index=0&id=19ad3351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad3351",
  null
  
)

export default component.exports